import { createActions, createReducer } from 'reduxsauce'

import ConsultaDetalhamentoDespesasService from '../../servicos/ConsultaDetalhamentoDespesasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaDetalhamentoDespesasInicio: [],
    buscaConsultaDetalhamentoDespesasErro: ['erro'],
    buscaConsultaDetalhamentoDespesasSucesso: ['consultaDetalhamentoDespesas'],
    limpar: [],
    setConsultaDetalhamentoDespesasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaDetalhamentoDespesas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaDetalhamentoDespesasInicio())
        let serv = new ConsultaDetalhamentoDespesasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaDetalhamentoDespesasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaDetalhamentoDespesasErro(error)))
    }
}

const buscaConsultaDetalhamentoDespesasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaDetalhamentoDespesasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaDetalhamentoDespesasSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaDetalhamentoDespesas.resultado,
        dataSincronizacaoDados: action.consultaDetalhamentoDespesas.dataSincronizacaoDados,
        fonte: action.consultaDetalhamentoDespesas.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaDetalhamentoDespesasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_DETALHAMENTO_DESPESAS_INICIO]: buscaConsultaDetalhamentoDespesasInicio,
    [Types.BUSCA_CONSULTA_DETALHAMENTO_DESPESAS_ERRO]: buscaConsultaDetalhamentoDespesasErro,
    [Types.BUSCA_CONSULTA_DETALHAMENTO_DESPESAS_SUCESSO]: buscaConsultaDetalhamentoDespesasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_DETALHAMENTO_DESPESAS_ESTADO_DT]: setConsultaDetalhamentoDespesasEstadoDT,
})
